import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.vue?vue&type=style&index=0&id=c1a6e76c&lang=css"

const __exports__ = script;

export default __exports__